import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {RefreshCw} from 'lucide-react';
import {Button} from '@chekinapp/ui';
import {useRetryAppLoad} from 'hooks/useRetryAppLoad';
import {ErrorScene} from 'components/ErrorScene';
import {TrustFooter} from 'components/TrustFooter';

function LoadErrorView() {
  const {t} = useTranslation();
  const retryAppLoad = useRetryAppLoad();
  const [announceOverride, setAnnounceOverride] = useState('');

  const handleRetry = () => {
    setAnnounceOverride(t('splash_retry_announce'));
    retryAppLoad();
  };

  return (
    <ErrorScene
      variant="crash"
      title={t('splash_error_title')}
      subtitle={t('splash_error_subtitle')}
      announce={announceOverride || t('splash_error_announce')}
    >
      <div className="mt-6 flex w-full max-w-[300px] flex-col gap-2.5">
        <Button variant="primary" onClick={handleRetry}>
          <RefreshCw size={16} aria-hidden="true" />
          {t('try_again')}
        </Button>
      </div>
      <TrustFooter variant="scene" />
    </ErrorScene>
  );
}

export {LoadErrorView};
